<template>
  <div :class="divClass">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" height="0" width="0">
      <defs>
        <linearGradient id="loading">
          <stop stop-color="var(--header-bg)" stop-opacity="1" offset="0">
            <animate attributeName="stop-opacity" values="0;1" dur="1.5s" repeatCount="indefinite"></animate>
          </stop>
          <stop stop-color="var(--header-bg)" stop-opacity=".5" offset=".5">
            <animate attributeName="offset" from="0" to="2" dur="1.5s"
              repeatCount="indefinite"></animate>
          </stop>
          <stop stop-color="var(--header-bg)" stop-opacity="1" offset="1"/>
        </linearGradient>
      </defs>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoading",
  props: {
    divClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
</style>
